function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { usePrefixCls } from '@byte-design/config';
import { useBoolean } from '@bydesign-ui/hooks';
import { classnames } from '@bydesign-ui/utils';
import { Button } from '../button';
export var ModalFooter = function ModalFooter(props) {
  var className = props.className,
      _props$align = props.align,
      align = _props$align === void 0 ? 'start' : _props$align,
      children = props.children,
      attrs = _objectWithoutProperties(props, ["className", "align", "children"]);

  var cls = classnames(usePrefixCls('modal-footer', _defineProperty({}, "align-".concat(align), true)), className);
  return React.createElement("div", Object.assign({
    className: cls
  }, attrs), children);
};
ModalFooter.displayName = 'ModalFooter';
export var InternalModalFooter = React.forwardRef(function (props, ref) {
  var className = props.className,
      _props$align2 = props.align,
      align = _props$align2 === void 0 ? 'start' : _props$align2,
      showCancelButton = props.showCancelButton,
      cancelButtonProps = props.cancelButtonProps,
      cancelButtonclassName = props.cancelButtonclassName,
      onCancelCallback = props.onCancelCallback,
      cancelText = props.cancelText,
      okButtonclassName = props.okButtonclassName,
      okButtonProps = props.okButtonProps,
      onOkCallback = props.onOkCallback,
      okText = props.okText,
      extra = _objectWithoutProperties(props, ["className", "align", "showCancelButton", "cancelButtonProps", "cancelButtonclassName", "onCancelCallback", "cancelText", "okButtonclassName", "okButtonProps", "onOkCallback", "okText"]);

  var _useBoolean = useBoolean(false),
      _useBoolean2 = _slicedToArray(_useBoolean, 2),
      confirmLoading = _useBoolean2[0],
      _useBoolean2$ = _useBoolean2[1],
      showLoading = _useBoolean2$.setTrue,
      hideLoading = _useBoolean2$.setFalse;

  React.useImperativeHandle(ref, function () {
    return {
      showLoading: showLoading,
      hideLoading: hideLoading
    };
  });
  return React.createElement(ModalFooter, Object.assign({
    className: className,
    align: align
  }, extra), showCancelButton && React.createElement(Button, Object.assign({
    type: "default"
  }, cancelButtonProps, {
    className: cancelButtonclassName,
    onClick: onCancelCallback
  }), cancelText), React.createElement(Button, Object.assign({
    type: "primary",
    className: okButtonclassName,
    loading: confirmLoading,
    onClick: onOkCallback
  }, okButtonProps), okText));
});